var _ = require('underscore');
var Backbone = require('backbone');
var STATIC = require('./statics');
var helpers = require('./helpers');

var readyResponses = {};

function logReadyResponse(e) {
  var id;
	if(helpers.isSwMessage(e) && e.data.action === STATIC.EVENTS.OTHER_WINDOW_READY) {
    id = e.origin + e.data.instId;
		readyResponses[id] = readyResponses[id] || {};
		readyResponses[id][e.data.pairID] = true;
	}
}

function isAlreadyReady(signatureInfo) {
  var id = signatureInfo.origin + signatureInfo.instId;
	return readyResponses[id] && readyResponses[id][signatureInfo.pairID];
}

function bustReadyResponses() {
  readyResponses = {};
}

function EventDelegator() {}

_.extend(EventDelegator.prototype, Backbone.Events);

var eventDelegator = new EventDelegator();

// Listen for all events on window
// TODO: (should probably be moved outside constructor)
window.addEventListener('message', function triggerWindowEvents(e) {
	logReadyResponse(e);
	eventDelegator.trigger('windowEvent', e);
}, window);

module.exports = {
	eventDelegator: eventDelegator,
	isAlreadyReady: isAlreadyReady,
  bustReadyResponses: bustReadyResponses
};
